// extracted by mini-css-extract-plugin
export var body = "body-module--body--rr+rz";
export var bodyBlock = "body-module--bodyBlock--zoYNQ";
export var bodyBlockGallery = "body-module--bodyBlockGallery--jY+4D";
export var bodyBlockImage = "body-module--bodyBlockImage--DuL5d";
export var bodyBlockGalleryCaption = "body-module--bodyBlockGalleryCaption--1dRv5";
export var bodyBlockImageCaption = "body-module--bodyBlockImageCaption--vbz3J";
export var bodyBlockBlockquote = "body-module--bodyBlockBlockquote--pylUg";
export var bodySection = "body-module--bodySection--w8Mf5";
export var bodyTextSection = "body-module--bodyTextSection--l2qA6";
export var bodyInsetColumn = "body-module--bodyInsetColumn--AuXo8";
export var bodyInsetColumnInner = "body-module--bodyInsetColumnInner--Ps44X";